<template>
  <div>
    {{ inputValues }}
    <div v-for="(item, index) in inputValues" :key="index" class="input-row">
      <div class="input-item">
        <el-form v-for="(tagItem, index) in tagList" :key="index" size="mini" inline lable-width="100px">
        <el-row>
          <el-col :span="23">
            <el-form-item v-for="item in tagItem" :key="item.lang" :label="item.label">
              <el-input v-model="item.value" class="width-80" @change="handleChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-button
              size="mini"
              icon="el-icon-delete"
              type="danger"
              circle
              @click="remove(index)"
              class="me-2"
            ></el-button>
          </el-col>
        </el-row>
      </el-form>
        <el-input
          placeholder="第几天"
          v-model="item.key"
          @input="handleChange"
          :disabled="disabled"
        ></el-input>
        <el-input
          placeholder="利率百分比(0-1之间)"
          v-model="item.value"
          @input="handleChange"
          :disabled="disabled"
        ></el-input>
        
      </div>
      <el-button
        v-if="index"
        type="primary"
        icon="el-icon-minus"
        circle
        @click="removeInput(index)"
      ></el-button>
    </div>
    <el-button
      type="primary"
      icon="el-icon-plus"
      circle
      @click="addInput"
    ></el-button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'mutipleTags',
  props: ['value', 'disabled'],
  data() {
    return {
      inputValues:
        this.value && this.value.length
          ? this.value.concat()
          : [{ key: '', value: '' }],
      newPair: '',
      ProductLang: [
        { lang: "zh",value:'', label: "中文" },
        { lang: "hk",value:'', label: "繁体" },
        { lang: "en",value:'', label: "英文" },
        { lang: "ko",value:'', label: "韩文" },
        { lang: "jp",value:'', label: "日文" },
        { lang: "ru",value:'', label: "俄文" },
        { lang: "tr",value:'', label: "土耳其文" },
        { lang: "vi",value:'', label: "越南文" },
        { lang: "th",value:'', label: "泰文" },
      ],
      tagList:[]
    };
  },
  computed: {},
  watch: {
    value: {
      handler(val, oldVal) {
        this.inputValues =
          val && val.length ? val.concat() : [{ key: '', value: '' }];
      },
      deep: true
    }
  },
  methods: {
    handleChange() {
      this.$emit('change', this.inputValues);
      this.$emit('input', this.inputValues);
      this.$parent.$emit('el.form.change', this.inputValues);
    },
    addInput() {
      this.inputValues.push({ key: '', value: '' });
    },
    removeInput(index) {
      this.inputValues.splice(index, 1);
    }
  }
};
</script>

<style lang="less" scoped>
.input-row {
  margin-bottom: 10px;
  display: flex;
}
.el-input {
  width: auto;
}
.recommand {
  margin-left: 10px;
  font-size: 13px;
}
</style>
